
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recruitment-fraud",
      function () {
        return require("private-next-pages/recruitment-fraud.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recruitment-fraud"])
      });
    }
  